/* eslint-disable lines-around-comment */
/** 手机号码正则 */
export const MOBILE_PATTERN = /^1((3\d)|(4[578])|(5[0-3,5-9])|(6[67])|(7[1-3,5-8])|(8\d)|(9[013,5-9])|(44))\d{8}$/;
/** 固定电话号码正则 */
export const PHONE_PATTERN = /(^0[1-9]{2,3}-\d{7,9}$)/;
/** 身份证号正则 */
export const ID_CARD_PATTERN =
    /(^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$|^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)/;
